// extracted by mini-css-extract-plugin
export default {"bg-13":"TestimonialSession_bg-13__dKoJl","bg-12":"TestimonialSession_bg-12__KOIDt","bg-2":"TestimonialSession_bg-2__KE5qC"};